import { defineMessages } from "react-intl";

export const messages = defineMessages({
  cadenceInterval: {
    id: "listModalForCharts.column.cadenceInterval",
    defaultMessage: "Cadence Interval",
    description: "Cadence interval column header in list modal for charts",
  },
  cadenceIntervalTag: {
    id: "listModalForCharts.column.cadenceInterval.tag",
    defaultMessage: "{group}: {cadenceInterval} {cadenceInterval, plural, one {day} other {days}}",
    description: "CadenceInterval column info in list modal for charts",
  },
  cadenceStatus: {
    id: "listModalForCharts.column.cadenceStatus.display",
    defaultMessage: "{cadenceDaysOut} {cadenceDaysOut, plural, one {day} other {days}} overdue",
    description: "CadenceDaysOut column info in list modal for charts",
  },
  cadenceStatusTitle: {
    id: "listModalForCharts.column.cadenceStatus.title",
    defaultMessage: "Frequency Status",
    description: "CadenceDaysOut column header in list modal for charts",
  },
  createdAt: {
    id: "listModalForCharts.column.createdAt",
    defaultMessage: "Created on",
    description: "Created At column header in list modal for charts",
  },
  name: {
    id: "listModalForCharts.column.name",
    defaultMessage: "Record",
    description: "Name column header in list modal for charts",
  },
  owner: {
    id: "listModalForCharts.column.owner",
    defaultMessage: "Owner",
    description: "Owner column header in list modal for charts",
  },
  sourceCreated: {
    id: "listModalForCharts.column.sourceCreated",
    defaultMessage: "Source",
    description: "Source created column header in list modal for charts",
  },
  user: {
    id: "listModalForCharts.column.user",
    defaultMessage: "Created by",
    description: "Created by column header in list modal for charts",
  },
});
